import { nextTick } from 'vue';

export default {
  mounted(el) {
    nextTick(() => {
      const options = {
        speed: parseFloat(el.dataset.rellaxSpeed) || -2,
      };

      if (el) {
        // グローバルスコープのRellaxを使用
        new Rellax(el, options);
      } else {
        console.error('対象の要素が見つかりません:', el);
      }
    });
  },
};


/*
 使用例
<template>
  <div>
    <div v-rellax data-rellax-speed="-0.4" data-rellax-percentage="0.5">
      これはパララックスの対象です
    </div>
  </div>
</template>
*/